<template>
  <b-col sm="12" md="12" lg="12" xl="12">
    <b-form-group
      label="Lote do desinfetante"
      label-for="loteDesinfetante"
    >
      <b-form-input
        name="loteDesinfetante"
        v-model="lote_desinfetante"
        @input="(v) => $emit('updateModel', { lote_desinfetante: v })"
        class="invision-input input-icon"
        :disabled="isBusy"
        v-validate="{ required: true }"
        :state="validateState('loteDesinfetante')"
      ></b-form-input>
    </b-form-group>
  </b-col>
</template>

<script>
export default {
  name: 'LoteDesinfetante',
  inject: ['validator', 'validateState'],
  created() {
    this.$validator = this.validator;
  },

  data() {
    return {
      lote_desinfetante: '',
    };
  },

  props: {
    isBusy: {
      type: Boolean,
    },
    options: {
      type: Object,
      required: false,
    },
  },
};
</script>
